import React from 'react';
import {
    FormTab,
    TextInput,
    NumberInput,
    DateInput,
    BooleanInput,
} from 'react-admin';

import Create from '../common/views/Create';
import TabbedForm from '../common/forms/TabbedForm';
import CostFrequencyField from './inputs/CostFrequencyInput';


const CostCreate = props => (
    <Create {...props}>
        <TabbedForm redirect="list">
            <FormTab label="summary">
            
                <CostFrequencyField />
                <TextInput source="name" fullWidth />
                <TextInput source="vendor" />
                <TextInput source="category" />

                <NumberInput source="amount" />
                <NumberInput source="amount_min" />
                <NumberInput source="amount_max" />

                <NumberInput source="variation_pct" />
                <BooleanInput source="is_variable" />
                <DateInput source="start_date" />
                <DateInput source="end_date" />

            </FormTab>
        </TabbedForm>
    </Create>
);

export default CostCreate;